
export default {
  props: ["src", "name", "path", "productDes"],
};
